import React from "react";
import ReactDOM from "react-dom";
import "./scss/index.scss";
import Router from "./components/Router";

// import Raven from "raven-js";
require("dotenv").config();
// Raven.config(process.env.REACT_APP_SENTRY).install();

ReactDOM.render(<Router />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js